import {ResponsiveContent} from "../ResponsiveNavTabs";
import React, {useEffect, useState} from "react";
import {Button, Stack} from "react-bootstrap";
import {useNavigate, useSearchParams} from "react-router-dom";
import {useAlert, useAuth} from "../../context";
import {PageTitle, SingleText} from "../_components";
import {Formik, Form as FormikForm} from "formik";
import * as yup from "yup";

export function VerifyEmail() {
    return <ResponsiveContent body={<VerifyEmailBody/>}/>
}

function VerifyEmailBody() {

    const [searchParams] = useSearchParams({token: ""});
    const navigate = useNavigate();
    const {verifyEmail} = useAuth();
    const {success, error} = useAlert();
    const [token, setToken] = useState("");


    const validationSchema = yup.object().shape({
        token: yup.string()
            .required("Token is missing."),
    })

    useEffect(() => {
        const token = searchParams.get("token");
        if (token) {
            // Automatically verify submitted token if passed as a search parameter in the GET
            console.debug("Automatically verify token:", token);
            setToken(token)
            verifyEmail({token: token})
                .then(resp => {
                    if (resp.success) {
                        navigate("/account/login");
                        success(<p>Account verified successfully, you can now login.</p>, "Success!");

                    } else {
                        error(resp.message, "Server error");
                    }
                })
                .catch(console.warn)
        }
    }, []);

    const value = {
        token: token
    }

    function handleSubmit(values, actions) {
        verifyEmail(values)
            .then(resp => {
                if (resp.success) {
                    navigate("/account/login");
                    success(<p>Account verified successfully, you can now login.</p>, "Success!");

                } else {
                    error(resp.message, "Server error");
                }
            })
            .catch(console.warn)
            .finally(() => actions.setSubmitting(false))
    }

    return (
        <>
            <PageTitle title="Verify Email">Use the token received in the verification email to verify your email.</PageTitle>

            <Formik validationSchema={validationSchema} onSubmit={handleSubmit} initialValues={value} enableReinitialize={true}>
                {({isSubmitting, resetForm}) => (
                    <FormikForm>

                        <SingleText name="token" type="textarea" label="Token"/>

                        <Stack direction="horizontal" gap="2" className="py-3 justify-content-end">
                            <Button type="reset" variant="secondary" onClick={resetForm}>Reset</Button>
                            <Button type="submit" variant="primary" disabled={isSubmitting}>Submit</Button>
                        </Stack>

                    </FormikForm>
                )}
            </Formik>

        </>
    )
}